import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=2aead974&scoped=true&"
import script from "./extend.vue?vue&type=script&lang=js&"
export * from "./extend.vue?vue&type=script&lang=js&"
import style0 from "./extend.vue?vue&type=style&index=0&id=2aead974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aead974",
  null
  
)

/* custom blocks */
import block0 from "./extend.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports